export const enum ObjectType{
    IMAGE,
    TEXT,
    CIRCLE,
    RECT,
    VECTOR,
    GROUP,
    SOURCE
}